import Vue from 'vue'
import Router from 'vue-router'
// import MainService from '@/components/main'
import RegisterService from '@/components/registration'
import TestService from '@/components/test'

Vue.use(Router)
let routes = []

// Import Registered Services
importServices([
  RegisterService,
  TestService
])

// Initialize Router
let router = new Router({
  mode: 'history',
  routes
})

router.beforeEach((to, from, next) => {
  Event.$emit('page:loading', true)
  next()
})

async function importServices(services) {
  for (let i = 0; i < services.length; i++) {
    let service = services[i]
    routes = routes.concat(service.routes)
  }
}

export default router